import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import dayjs from "dayjs";
import { STATUS_GOOD, STATUS_CRITICAL, TEXT_PRIMARY, GRIDLINE } from "./palette";
import { formatAmount } from "./format";

const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1em;
  padding: 0.4em 0;
  color: ${TEXT_PRIMARY};

  &:not(:first-child) {
    border-top: 1px solid ${GRIDLINE};
  }
`;

const Label = styled.div`
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Amount = styled.div`
  flex-shrink: 0;
  font-weight: 600;
  color: ${(props) => props.$color};
`;

// 用在 SpendingDetailModal 的緊湊單行列表：filter 已經固定了 note 或分類其中一個維度
// （顯示在 Modal 標題），這裡只需要顯示「另一個會隨列變化的欄位」，避免重複顯示已知資訊。
// showCategory=true（依 note 篩選時）顯示分類名稱；false（依分類篩選時）顯示 note。
export default function SpendingDetailRow({ spending, showCategory }) {
  const isIncome = spending.category.type === "income";
  const date = dayjs(Number(spending.date)).format("YYYY/MM/DD");
  const label = showCategory ? spending.category.name : spending.note;

  return (
    <Row>
      <Label>
        {date} · {label}
      </Label>
      <Amount $color={isIncome ? STATUS_GOOD : STATUS_CRITICAL}>
        {isIncome && "+"}
        {formatAmount(spending.amount)}
      </Amount>
    </Row>
  );
}

SpendingDetailRow.propTypes = {
  spending: PropTypes.shape({
    date: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    category: PropTypes.shape({ name: PropTypes.string, type: PropTypes.string }).isRequired,
  }).isRequired,
  showCategory: PropTypes.bool,
};

SpendingDetailRow.defaultProps = {
  showCategory: true,
};
